(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function sleep(ms) {
    return new Promise(function (res) { setTimeout(res, ms); });
  }

  // --- Cart helpers (identique à ton code, simplifié = garde ce qui marche) ---
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function showDrawerUpdatingState() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    var scrollable = drawer.querySelector('.drawer__scrollable');
    if (!scrollable) return;
    if (scrollable.querySelector('[data-cart-updating]')) return;

    var note = document.createElement('div');
    note.setAttribute('data-cart-updating', 'true');
    note.style.padding = '12px 16px';
    note.style.opacity = '0.75';
    note.textContent = 'Ajout en cours…';
    scrollable.prepend(note);
  }

  function clearDrawerUpdatingState() {
    var el = document.querySelector('#CartDrawer [data-cart-updating]');
    if (el) el.remove();
  }

  function getCart() {
    return fetchJSON(window.Shopify.routes.root + 'cart.js?_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    });
  }

  async function waitForCartCountIncrease(beforeCount, timeoutMs) {
    var start = Date.now();
    var limit = timeoutMs || 7000;

    while (Date.now() - start < limit) {
      try {
        var cart = await getCart();
        if (typeof cart.item_count === 'number' && cart.item_count > beforeCount) return cart;
      } catch (e) {}
      await sleep(200);
    }
    return getCart().catch(function () { return null; });
  }

  function addToCart(variantId, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty || 1) })
    }).then(function (r) {
      if (!r.ok) throw new Error('Erreur ajout panier');
      return r.json();
    });
  }

  function getSectionsHTML() {
    var url = window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble&_=' + Date.now();
    return fetchJSON(url, { credentials: 'same-origin', cache: 'no-store' });
  }

  function renderCartDrawerContents(sections) {
    var html = sections && sections['cart-drawer'];
    if (!html) return false;

    var doc = parseHTML(html);
    var currentDrawer = document.querySelector('#CartDrawer');
    var freshDrawer = doc.querySelector('#CartDrawer');
    if (!currentDrawer || !freshDrawer) return false;

    currentDrawer.innerHTML = freshDrawer.innerHTML;
    currentDrawer.className = freshDrawer.className;
    return true;
  }

  function renderCartBubble(sections) {
    var bubbleHTML = sections && sections['cart-icon-bubble'];
    if (!bubbleHTML) return false;

    var currentBubble =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('[data-cart-count]') ||
      document.querySelector('.cart-link__bubble');

    if (!currentBubble) return false;

    var doc = parseHTML(bubbleHTML);
    var freshBubble =
      doc.querySelector('#cart-icon-bubble') ||
      doc.querySelector('[data-cart-count]') ||
      doc.querySelector('.cart-link__bubble');

    if (!freshBubble) return false;

    currentBubble.outerHTML = freshBubble.outerHTML;
    return true;
  }

  async function refreshCartUI() {
    var sections = await getSectionsHTML();
    var success = renderCartDrawerContents(sections);
    renderCartBubble(sections);

    if (success) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections: sections } }));
      document.dispatchEvent(new CustomEvent('cart:updated:drawer'));
      await sleep(50);
    }
  }

  function setButtonState(btn, state, originalText) {
    var textSpan = btn.querySelector('.carousel-add-to-cart-text');
    if (state === 'loading') {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (textSpan) textSpan.textContent = 'Ajout...';
      return;
    }
    if (state === 'success') { if (textSpan) textSpan.textContent = '✓ Ajouté'; return; }
    if (state === 'error') { if (textSpan) textSpan.textContent = '✗ Erreur'; return; }

    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    if (textSpan) textSpan.textContent = originalText;
  }

  var cartQueue = Promise.resolve();

  function initAddToCart(scope) {
    var root = scope || document;
    root.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
      if (btn.dataset.init === 'true') return;
      btn.dataset.init = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var textSpan = btn.querySelector('.carousel-add-to-cart-text');
        var originalText = textSpan ? textSpan.textContent : '';

        cartQueue = cartQueue.then(async function () {
          var before = await getCart().catch(function () { return { item_count: 0 }; });
          var beforeCount = before && typeof before.item_count === 'number' ? before.item_count : 0;

          showDrawerUpdatingState();
          setButtonState(btn, 'loading', originalText);

          try {
            await addToCart(variantId, 1);
            await waitForCartCountIncrease(beforeCount, 3000);
            await refreshCartUI();
            clearDrawerUpdatingState();
            setButtonState(btn, 'success', originalText);
            setTimeout(function () { setButtonState(btn, 'reset', originalText); }, 600);
          } catch (err) {
            console.error('[PCS cart] error:', err);
            clearDrawerUpdatingState();
            setButtonState(btn, 'error', originalText);
            setTimeout(function () { setButtonState(btn, 'reset', originalText); }, 1000);
          }
        });
      });
    });
  }

  // --- Flickity init ---
  function isMobile() { return window.innerWidth <= 767; }
  function syncViewportHeight(flkty) {
    if (!flkty || !flkty.viewport) return;

    var selected = flkty.selectedElement;
    if (!selected) return;

    // hauteur réelle de la card sélectionnée
    var h = selected.getBoundingClientRect().height;
    if (!h) return;

    flkty.viewport.style.height = Math.ceil(h) + 'px';
  }

  function attachDragClasses(flkty, elem) {
    function add() {
      elem.classList.add('is-dragging');
      var track = elem.querySelector('.flickity-slider');
      if (track) track.classList.add('is-dragging');
    }
    function remove() {
      elem.classList.remove('is-dragging');
      var track = elem.querySelector('.flickity-slider');
      if (track) track.classList.remove('is-dragging');
    }
    flkty.on('dragStart', add);
    flkty.on('pointerDown', add);
    flkty.on('dragEnd', remove);
    flkty.on('pointerUp', remove);
    flkty.on('settle', remove);
  }

      function initMainCarousel(sectionEl) {
    var main = sectionEl.querySelector('.js-carousel-main');
    if (!main || typeof Flickity === 'undefined') return;

    var mode = isMobile() ? 'mobile' : 'desktop';
    if (main._pcsMode === mode && main._pcsFlickity) return;

    if (main._pcsFlickity) {
      try { main._pcsFlickity.destroy(); } catch (e) {}
      main._pcsFlickity = null;
    }

    var settle = Number(main.getAttribute('data-settle') || 250);
    var wrap = String(main.getAttribute('data-wrap')) === 'true';
    var dots = String(main.getAttribute('data-dots')) === 'true';
    var arrows = String(main.getAttribute('data-arrows')) === 'true';
    var mobileOne = String(main.getAttribute('data-mobile-one')) === 'true';

    var flkty = new Flickity(main, {
      cellSelector: '.carousel-product-card',
      cellAlign: mode === 'mobile' ? 'center' : 'left',
      contain: true,
      wrapAround: wrap,
      pageDots: dots,
      prevNextButtons: arrows,
      draggable: true,

      imagesLoaded: true,
      adaptiveHeight: true,
      setGallerySize: true,

      // ⚠️ à éviter ici car tes <img> ont déjà loading="lazy"
      // lazyLoad: 2,

      groupCells: (mode === 'desktop') ? false : (mobileOne ? 1 : false),
      settleDuration: settle
    });

    attachDragClasses(flkty, main);
    main._pcsFlickity = flkty;
    main._pcsMode = mode;

    // --- Fix hauteur viewport (évite le gros vide) ---
    function syncViewportHeight() {
      if (!flkty || !flkty.viewport) return;
      var selected = flkty.selectedElement;
      if (!selected) return;
      var h = selected.getBoundingClientRect().height;
      if (!h) return;
      flkty.viewport.style.height = Math.ceil(h) + 'px';
    }

    syncViewportHeight();
    flkty.on('ready', syncViewportHeight);
    flkty.on('select', syncViewportHeight);
    flkty.on('settle', syncViewportHeight);
    flkty.on('imagesLoaded', function () {
      flkty.resize();
      syncViewportHeight();
    });

    window.addEventListener('load', function () {
      flkty.resize();
      syncViewportHeight();
    }, { once: true });
  }


  function initSpecsCarousels(sectionEl) {
    if (typeof Flickity === 'undefined') return;
    sectionEl.querySelectorAll('.js-carousel-specs').forEach(function (specEl) {
      if (specEl._pcsFlickity) return;

      var settle = Number(specEl.getAttribute('data-settle') || 200);

      var flkty = new Flickity(specEl, {
        cellSelector: '.mf-specs__cell',
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        freeScroll: false,
        wrapAround: false,
        setGallerySize: true,
        settleDuration: settle
      });

      attachDragClasses(flkty, specEl);
      specEl._pcsFlickity = flkty;
    });
  }

  function initSection(sectionEl) {
    initAddToCart(sectionEl);
    initMainCarousel(sectionEl);
    initSpecsCarousels(sectionEl);
  }

  function initAll() {
    document.querySelectorAll('.product-carousel-section[data-section-id]').forEach(initSection);
  }

  function boot() {
    initAll();
    window.addEventListener('resize', debounce(initAll, 250));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target && e.target.querySelector
      ? e.target.querySelector('.product-carousel-section[data-section-id]')
      : null;
    if (sectionEl) initSection(sectionEl);
    else initAll();
  });
})();
